// extracted by mini-css-extract-plugin
export default {"scrollbarContainer":"BrNSWPpOGa_MupIj_RFF","scrollbarInner":"B82uHgHZVQ7uTebuSGoA","scrollbarInput":"bzp5DLXrM7ne5sj3eiFd"};